import { camelizeKeys } from '@skytech/utils'

import { get } from '@/util/auth'

import { API_ROUTE_ADMIN_USERS_LEGACY } from './api-routes'

const adminResources = {
  getUserList: async () => {
    const users = await get<unknown>(API_ROUTE_ADMIN_USERS_LEGACY)
    const parsedUsers = camelizeKeys(users)

    return parsedUsers as { customerName: string; id: number; name: string }[]
  },
}

export default adminResources
